export default __webpack_public_path__ + "28b2777428975102d404e82fcd970cf8.png";